import sha256 from 'js-sha256';

export default ({ $axios }, inject) => {
  // 将 sha256 函数注入到 Vue 实例中，方便在组件中使用
  inject('sha256', sha256);
};